module.exports = __webpack_public_path__ + "static/media/PRI.fe5ec1a0.svg";